export const homepageQuery = `
  query getHomepage {
    homepage {
      blocks {
        heading
        image {
          altText
          imageSrcset
          sourceUrl
        }
        more_link
        more_link_behavior
        more_link_text
        subheading
        text
        type
      }
      events {
        items {
          eventSlug
          featuredImage {
            node {
              altText
              sourceUrl
            }
          }
          imageSrcset
          repeatDescription
          specificImage {
            altText
            imageSrcset
            sourceUrl
          }
          start {
            day
            isoDate
            meridiem
            month
            time
            timezone
            year
            weekday
          }
          title
          venue
        }
        more_link
        more_link_text
        title
      }
      excerpt
      exhibitions {
        items {
          callToAction {
            label
            link
          }
          dates {
            formatted
          }
          featuredImage {
            altText
            sourceUrl
          }
          imageSrcset
          title
          url
        }
        more_link
        more_link_text
      }
      featured {
        exhibition {
          dates {
            formatted
          }
          featuredImage {
            altText
            sourceUrl
          }
          imageSrcset
          title
          url
        }
        header
        more_link
        more_link_text
      }
      featuredImage {
        altText
        sourceUrl
      }
      featuredImageWidth
      imageSrcset
      mainTitle
      mediaBanner {
        altText
        carouselItems {
          altText
          caption
          captionLink
          enableDescription
          enableLink
          enablePlayPause
          enableSound
          imageFile
          imageSrcset
          imageUrl
          itemType
          linksTo
          muxLongVideoId
          muxShortVideoId
          muxVideoMobileId
          videoFile
        }
        enabled
        enableDescription
        enableLink
        enablePlayPause
        enableSound
        caption
        captionLink
        itemType
        imageFile
        imageSrcset
        imageUrl
        linksTo
        mediaType
        muxLongVideoId
        muxShortVideoId
        muxVideoMobileId
        videoFile
      }
      quickLinks {
        link
        link_behavior
        link_text
      }
    }
  }
`;
